import React from 'react';
import { Leaf, Users, FileCheck } from 'lucide-react';

export const ESGCommitment = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-pink-50 via-white to-rose-50">
      <div className="container mx-auto px-6">
        {/* Title */}
        <div className="text-center mb-12 max-w-3xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-3">
            Compromisso <span className="text-[#eb068c]">ESG</span>
          </h2>
          <p className="text-base md:text-lg text-gray-600 italic">
            (Environmental, Social and Governance — Ambiental, Social e Governança)
          </p>
          <div className="w-20 h-1 bg-gradient-to-r from-[#eb068c] to-[#c7056f] mx-auto rounded-full mt-6"></div>
        </div>

        {/* Cards */}
        <div className="max-w-6xl mx-auto grid md:grid-cols-3 gap-6">
          {/* Ambiental (E) */}
          <div className="group bg-white rounded-2xl p-7 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-pink-100 relative overflow-hidden">
            <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-[#20BA5A]/10 to-transparent rounded-full blur-2xl -mr-10 -mt-10 pointer-events-none"></div>
            <div className="relative">
              <div className="w-14 h-14 bg-gradient-to-br from-[#20BA5A] to-[#178C41] rounded-2xl flex items-center justify-center shadow-lg mb-5 group-hover:scale-110 transition-transform">
                <Leaf className="h-7 w-7 text-white" />
              </div>
              <div className="flex items-baseline gap-2 mb-3">
                <h3 className="text-xl font-bold text-gray-900">Ambiental</h3>
                <span className="text-2xl font-extrabold text-[#20BA5A]">(E)</span>
              </div>
              <p className="text-gray-600 leading-relaxed">
                Produzido com práticas sustentáveis e materiais ecologicamente corretos. Produto atóxico, durável e desenvolvido para minimizar impactos ao meio ambiente.
              </p>
            </div>
          </div>

          {/* Social (S) */}
          <div className="group bg-white rounded-2xl p-7 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-pink-100 relative overflow-hidden">
            <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-[#eb068c]/10 to-transparent rounded-full blur-2xl -mr-10 -mt-10 pointer-events-none"></div>
            <div className="relative">
              <div className="w-14 h-14 bg-gradient-to-br from-[#eb068c] to-[#c7056f] rounded-2xl flex items-center justify-center shadow-lg mb-5 group-hover:scale-110 transition-transform">
                <Users className="h-7 w-7 text-white" />
              </div>
              <div className="flex items-baseline gap-2 mb-3">
                <h3 className="text-xl font-bold text-gray-900">Social</h3>
                <span className="text-2xl font-extrabold text-[#eb068c]">(S)</span>
              </div>
              <p className="text-gray-600 leading-relaxed">
                Criado através de uma rede colaborativa, com pequenos produtores e parceiros independentes. Incentiva o bem-estar, a conexão com a natureza e momentos de contemplação no dia a dia.
              </p>
            </div>
          </div>

          {/* Governança (G) */}
          <div className="group bg-white rounded-2xl p-7 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-pink-100 relative overflow-hidden">
            <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-amber-400/15 to-transparent rounded-full blur-2xl -mr-10 -mt-10 pointer-events-none"></div>
            <div className="relative">
              <div className="w-14 h-14 bg-gradient-to-br from-amber-500 to-amber-600 rounded-2xl flex items-center justify-center shadow-lg mb-5 group-hover:scale-110 transition-transform">
                <FileCheck className="h-7 w-7 text-white" />
              </div>
              <div className="flex items-baseline gap-2 mb-3">
                <h3 className="text-xl font-bold text-gray-900">Governança</h3>
                <span className="text-2xl font-extrabold text-amber-600">(G)</span>
              </div>
              <p className="text-gray-600 leading-relaxed">
                Empresa comprometida com ética, transparência fiscal e contábil, proteção de dados e relações comerciais responsáveis.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
